import React from 'react';
import { Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';


export const useSectionPaperStyles = makeStyles()(theme => ({
  paper: {
    position: 'relative',
    maxWidth: '650px',
    scrollMarginTop: '80px',
  },
  paperError: {
    border: `1px solid ${theme.palette.error.border}`
  },
}));


export const SectionPaper: React.FC<{
  id?: string;
  isError?: boolean;
}> = ({ id, isError, children }) => {
  const { classes, cx } = useSectionPaperStyles();

  return (
    <Paper
      id={id}
      className={cx(classes.paper, { [classes.paperError]: isError })}
      variant="outlined"
      square
    >
      {children}
    </Paper>
  );
};
